export const init = () => {

  // TRACKER 'PAYMENT'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.funnel.payment);

  // ProceedToConfirmation
  const proceedToConfirmation = new AnalyticsQueueEvent('proceedToConfirmation', tracker.defaultEvent());
  proceedToConfirmation.trigger = 'click';
  proceedToConfirmation.domElement = '[data-tid=pay-order-btn-main],[data-tid=pay-order-btn-column],.dkt-checkout-primary-button.cta-v2';
  proceedToConfirmation.options.action = 'ProceedToConfirmation';
  proceedToConfirmation.getLabel = () => `${tc_vars.order_id}|${getLastMeanOfPayment()}`;
  proceedToConfirmation.options.value = tc_vars.order_amount_ati_with_sf;
  proceedToConfirmation.postAction( () => {
    const orderInfo = tc_vars.order_id || '';
    CUBE.Analytics.setStorage(`dl-payment-${orderInfo}`, getLastMeanOfPayment());
  });
  tracker.addEvent(proceedToConfirmation);

  // SelectPaymentMethodBox
  const changePaymentMethodBox = new AnalyticsClickEvent('SelectPaymentMethod', tracker.defaultEvent());
  changePaymentMethodBox.domContainer = '.dkt-block';
  changePaymentMethodBox.domElement = '.dkt-block-header:not(.dkt-block-header--secondary)';
  changePaymentMethodBox.options.action = 'SelectPaymentMethod';
  changePaymentMethodBox.getLabel = $element => $element.closest('[data-payment-name]').data('payment-name');
  changePaymentMethodBox.stopEvent = function($element) {
    const isOpen = $element.closest('section').hasClass('dkt-block--open');
    const isEmpty = this.getLabel($element) === '';
    return isOpen || isEmpty;
  };
  tracker.addEvent(changePaymentMethodBox);

  // SelectPaymentMethodBox -- SPECIFIC FOR FAPIAO BOX
  const changePaymentMethodBoxFapiao = new AnalyticsClickEvent('SelectPaymentMethodFapiao', tracker.defaultEvent());
  changePaymentMethodBoxFapiao.domElement = '[data-target="#fapiao"]';
  changePaymentMethodBoxFapiao.options.action = 'OpenPaymentMethodBox';
  changePaymentMethodBoxFapiao.options.label = 'fapiao';
  changePaymentMethodBoxFapiao.stopEvent = $element => {
    const isClosed = $element.hasClass('collapsed');
    return !isClosed;
  };
  tracker.addEvent(changePaymentMethodBoxFapiao);

  // selectPaymentMethod (e-bank)
  const selectPaymentMethodEBank = new AnalyticsTriggerEvent('selectPaymentMethodEBank', tracker.defaultEvent());
  selectPaymentMethodEBank.trigger = 'change';
  selectPaymentMethodEBank.options.action = 'SelectPaymentMethod';
  selectPaymentMethodEBank.domElement = '[name="rb-bank"]';
  selectPaymentMethodEBank.getLabel = $element => {
    const mainType = $element.closest('[data-payment-name]').data('payment-name');
    const subType = $element.val();
    return `${mainType}-${subType}`;
  };
  tracker.addEvent(selectPaymentMethodEBank);

  // OpenGiftPaymentList
  const openGiftPaymentList = new AnalyticsTriggerEvent('openGiftPaymentList', tracker.defaultEvent());
  openGiftPaymentList.trigger = 'change';
  openGiftPaymentList.domElement = '[name="giftcard"][type="radio"]';
  openGiftPaymentList.options.action = 'SelectGiftPaymentList';
  openGiftPaymentList.getLabel = $elt => {
    if ($elt.attr('id').indexOf('-yes') > -1) return 'OpenGiftPayment';
    if ($elt.attr('id').indexOf('-no') > -1) return 'CloseGiftPayment';
    return false;
  };
  tracker.addEvent(openGiftPaymentList);

  // addGiftcardPayment
  const addGiftcardPayment = new AnalyticsClickEvent('addGiftcardPayment', tracker.defaultEvent());
  addGiftcardPayment.domElement = '.dkt-create-card';
  addGiftcardPayment.options.action = 'AddGiftcardPayment';
  addGiftcardPayment.options.label = tc_vars.order_id;
  tracker.addEvent(addGiftcardPayment);

  // removeGiftcardPayment
  const removeGiftcardPayment = new AnalyticsClickEvent('removeGiftcardPayment', tracker.defaultEvent());
  removeGiftcardPayment.domContainer = '.dkt-card--verso';
  removeGiftcardPayment.domElement = '.dkt-button-close';
  removeGiftcardPayment.options.action = 'RemoveGiftcardPayment';
  removeGiftcardPayment.options.label = tc_vars.order_id;
  tracker.addEvent(removeGiftcardPayment);

  // *** selectFapiaoMethod
  const selectFapiaoMethod = new AnalyticsTriggerEvent('selectFapiaoMethod', tracker.defaultEvent());
  selectFapiaoMethod.trigger = 'change';
  selectFapiaoMethod.options.action = 'SelectFapiaoMethod';
  selectFapiaoMethod.domElement = '#fapiao-block #fapiao-invoice';
  selectFapiaoMethod.getLabel = $element => $element.find('option:selected').val();
  tracker.addEvent(selectFapiaoMethod);


  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

  // UTIL METHOD
  const getLastMeanOfPayment = () => {
    const last = $('[data-payment-name].dkt-block--selected:not(.hidden)').data('payment-name');
    const $cards = $('.dkt-card-slider-item--selected');

    // is Payment With Giftcards ?
    if ($cards.length > 0) {
      // Get all types of cards
      const arrTypes = [];
      $cards.each(function(){
        const $card = $(this);
        if ($card.find('.dkt-card').length > 0) {
          const type = $card.find('.dkt-card')[0].className.split(' dkt-')[1].toUpperCase().trim();
          if (arrTypes.indexOf(type) === -1)
            arrTypes.push(type);
        }
      });
      // arrTypes now contains all types of giftcards / vouchers / ...

      /*
			> is Order Fully Paid With Giftcards ?
				'.panel-empty' is only displayed when there is no payment type selection
				(i.e. when the order is fully paid with gift card) > no need to send 'lastMeanOfPayment' info in this case
			*/
      if (last) {
        // Specific panel is hidden > There is still some payment options, so we add the selected one to array of Types
        arrTypes.unshift(last);
        return arrTypes.join(' - ');
      }
      // Panel is hidden > Order fully paid with giftcards / vouchers / ...
      return arrTypes.join(' - ');

    }
    // Payment without giftcards
    return last;

  };
  
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/payment-tracker.js